import {
  IMPACT_REPORT_CATEGORY_PREFIX,
  IMPACT_REPORT_KPI_PREFIX,
  ImpactReportCategory,
  ImpactType,
  Stages,
} from '@/impactReports/impactReport.types';
import { t } from 'i18next';

export function getCustomCategoryTitle(category: ImpactReportCategory) {
  return category?.category?.name?.substring(IMPACT_REPORT_CATEGORY_PREFIX.length) ?? '';
}

export function getKPIColumnName(kpiDisplayName: string, kpiUnit: string) {
  return `${IMPACT_REPORT_KPI_PREFIX}${kpiDisplayName}_${kpiUnit}`;
}

export function getKPIDisplayName(kpiColumnName: string) {
  return kpiColumnName.substring(IMPACT_REPORT_KPI_PREFIX.length, kpiColumnName.lastIndexOf('_')) ?? '';
}

export function getKPIUnit(kpiColumnName: string) {
  if (!kpiColumnName.startsWith(IMPACT_REPORT_KPI_PREFIX)) return '';
  return kpiColumnName.substring(kpiColumnName.lastIndexOf('_') + 1) ?? '';
}

export function getKPIItemColumnName(kpiColumnName: string) {
  return `${kpiColumnName}_item`;
}

export function getStageDisplayString(stage: Stages) {
  if (!stage) return '';
  if (t(`IMPACT_REPORT.${stage.toUpperCase()}`) === `IMPACT_REPORT.${stage.toUpperCase()}`) return stage;
  return t(`IMPACT_REPORT.${stage.toUpperCase()}`);
}

export function getCategoryDisplayString(
  categoryId: string,
  categories: { value: string; label: string }[] | undefined,
  fallback = '',
) {
  const category = categories?.find((category) => category.value === categoryId);
  return category ? category.label : fallback;
}

export function formatNumberAsValue(input: number | string, unit: string): string {
  const num = Number(input);
  if (!Number.isFinite(num)) return '';
  if (num >= 1_000_000) {
    return `${unit} ${(num / 1_000_000).toFixed(3)}M`;
  } else if (num >= 1_000) {
    return `${unit} ${(num / 1_000).toFixed(0)}K`;
  } else {
    return `${unit} ${new Intl.NumberFormat('en-US').format(Math.round(num))}`;
  }
}

export function getImpactTypeDisplayString(impactType: ImpactType) {
  switch (impactType) {
    case 'continuous':
      return t('IMPACT_REPORT.CONTINUOUS');
    case 'oneTime':
      return t('IMPACT_REPORT.ONE_TIME');
    case 'customCalc':
      return t('IMPACT_REPORT.CUSTOM_CALC');
    default:
      return impactType;
  }
}
